import { Chip, createStyles, IconButton, makeStyles, Typography } from "@material-ui/core";
import HeartFilledIcon from '@material-ui/icons/Favorite';
import HeartIcon from '@material-ui/icons/FavoriteBorder';
import React from "react";
import ReactCardFlip from 'react-card-flip';
import { ProfileItemModel } from "../models/profile-item.model";

type Props = {
    item: ProfileItemModel;
    is_liked?: boolean;
    onLike: () => void;
}

export const ProfileItem = ({
    item,
    is_liked,
    onLike,
}: Props) => {
    const classes = useStyles({});


    return <div className={classes.item}>
        <ReactCardFlip isFlipped={is_liked} flipDirection='vertical'>
            <div className={classes.front}>
                <div className={classes.header}>
                    <Typography variant='h6'><strong>{item.name}</strong> &middot; {item.sex}{item.age}</Typography>
                    <Typography variant='body1'>{item.city}</Typography>
                </div>
                <Typography variant='body2'><strong>GOALS</strong></Typography>
                <Typography gutterBottom variant='body1'>
                    <ul>
                        {item.goals.map((g: string, idx: number) => <li key={idx}>{g}</li>)}
                    </ul>
                </Typography>
                <Typography variant='body2'><strong>Family values</strong></Typography>
                <Typography gutterBottom variant='body1'>
                    {(item.family_values || []).map((g: any, idx: number) => <Chip className={classes.chip} key={idx} label={g.name} />)}
                </Typography>
                <Typography variant='body2'><strong>Financial values</strong></Typography>
                <Typography gutterBottom variant='body1'>
                    {(item.financial_values || []).map((g: any, idx: number) => <Chip className={classes.chip} key={idx} label={g.name} />)}
                </Typography>
                <Typography variant='body2'><strong>Spirituality</strong></Typography>
                <Typography gutterBottom variant='body1'>
                    {(item.spiritual_values || []).map((g: any, idx: number) => <Chip className={classes.chip} key={idx} label={g.name} />)}
                </Typography>
            </div>
            <div className={classes.back}>
                <div className='header'>
                    <Typography variant='h6'><strong>{item.name}</strong> &middot; {item.sex}{item.age}</Typography>
                    <Typography variant='body1'>{item.city}</Typography>
                </div>
                <img src={item.picture} />
            </div>
        </ReactCardFlip>
        <IconButton
            onClick={onLike}
            className={classes.crush}>
            {is_liked ? <HeartFilledIcon color='primary' /> : <HeartIcon />}
        </IconButton>
    </div>
}

const useStyles = makeStyles(theme => createStyles({
    item: {
        border: `1px solid ${theme.palette.divider}`,
        width: '100%',
        height: '100%',
        backgroundColor: 'white',
        position: 'relative',
    },
    header: {
        paddingBottom: theme.spacing(1),
        marginBottom: theme.spacing(1),
        borderBottom: `1px solid ${theme.palette.divider}`
    },
    crush: {
        position: 'absolute',
        right: theme.spacing(1),
        bottom: theme.spacing(1),
        background: 'white',
        boxShadow: theme.shadows[4],
        '&:hover': {
            background: 'white',
        }
    },
    chip: {
        margin: theme.spacing(.5),
    },
    front: {
        padding: theme.spacing(2),
    },
    back: {
        position: 'relative',
        height: 420,
        '& .header': {
            padding: theme.spacing(1),
            color: 'white',
            background: 'rgba(0, 0, 0, .6)',
            position: 'absolute',
            left: 0,
            bottom: 0,
            width: '100%',
        },
        '& img': {
            width: '100%',
            height: '100%',
            display: 'block',
            objectFit: 'cover',
        }
    },
}))